
seedWebApp.controller('ConfirmModalController', ['$scope', '$uibModalInstance', 'TranslationService', 'info',
    function ConfirmModalController($scope, $uibModalInstance, TranslationService, info) {

        $scope.translation = TranslationService.getActiveTranslation();
        console.log('ConfirmModalCtrl.order');
        console.log(info);

        $scope.info = info;

        $scope.ok = function () {
            $uibModalInstance.close($scope.info.Comments);
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };


    }]
);